import React from "react";
import { useFormikContext } from "formik";
import baseStyles from "../../style.module.scss";
import styles from "./style.module.scss";
import ReviewHeader from "../common/ReviewHeader";
import { dateFormatter } from "../../../../../../../../../components/helper/helper";
import useSalesFormStore from "../../../../../../../../stores/sales-form";
import { titlesOptions } from "../../../../../../../../../constants";
import IdvStatusBadge, {
  getIdvOutcome,
} from "../../../../../../../../components/IdvStatusBadge/IdvStatusBadge";

const PersonalInformation = ({ onEdit, isOpen, onToggle, complete }) => {
  const { values } = useFormikContext();
  const countryList = useSalesFormStore((state) => state.countryList);
  const idvRows = useSalesFormStore(
    (state) => state.applicationData?.powerapp_plaid_idv,
  );

  const formatPeriod = (years, months) => {
    const yearText =
      years > 0 ? `${years} year${years > 1 ? "s" : ""}` : "0 years";
    const monthText =
      months > 0 ? `${months} month${months > 1 ? "s" : ""}` : "0 months";
    return [yearText, monthText].filter(Boolean).join(" ");
  };

  const SectionHeader = ({ title, idvOutcome = null }) => (
    <div className={baseStyles.sectionHeader}>
      <span className={baseStyles.sectionTitle}>{title}</span>
      <IdvStatusBadge outcome={idvOutcome} />
      <div className={baseStyles.sectionLine} />
    </div>
  );

  const getCountryName = (countryCode) => {
    const country = countryList.find((c) => c.value === countryCode);
    return country ? country.label : countryCode;
  };

  const getOwnerTitle = (title) => {
    return titlesOptions.find((t) => t.value == +title)?.label || "-";
  };

  const getDocumentType = (documentType) => {
    if (documentType == "PASSPORT") return "Passport";
    if (documentType == "STATE_ID") return "State ID";
    if (documentType == "LOCAL_STATE_ID") return "Driver's License";
    return "-";
  };

  return (
    <div
      className={`${baseStyles.reviewSectionContainer} ${styles.personal_information}`}
    >
      <ReviewHeader
        title="Personal Information"
        isOpen={isOpen}
        onToggle={onToggle}
        onEdit={onEdit}
        complete={complete}
      />

      {isOpen && (
        <div className={baseStyles.reviewContent}>
          <div className={baseStyles.detailsGrid}>
            <div className={baseStyles.detailItem}>
              <div className={baseStyles.detailLabel}>Owner Title</div>
              <div className={baseStyles.detailValue}>
                {getOwnerTitle(values?.title)}
              </div>
            </div>
            <div className={baseStyles.detailItem}>
              <div className={baseStyles.detailLabel}>First Name</div>
              <div className={baseStyles.detailValue}>
                {values?.personal_first_name || "-"}
              </div>
            </div>
            <div className={baseStyles.detailItem}>
              <div className={baseStyles.detailLabel}>Last Name</div>
              <div className={baseStyles.detailValue}>
                {values?.personal_last_name || "-"}
              </div>
            </div>
            <div className={baseStyles.detailItem}>
              <div className={baseStyles.detailLabel}>Personal Phone</div>
              <div className={baseStyles.detailValue}>
                {values?.personal_phone || "-"}
              </div>
            </div>
            <div className={baseStyles.detailItem}>
              <div className={baseStyles.detailLabel}>Personal Email</div>
              <div className={baseStyles.detailValue}>
                {values?.personal_email || "-"}
              </div>
            </div>
          </div>

          <div className={baseStyles.section}>
            <SectionHeader title="ADDRESS" />
            <div className={baseStyles.detailsGrid}>
              <div className={baseStyles.detailItem}>
                <div className={baseStyles.detailLabel}>Street Address</div>
                <div className={baseStyles.detailValue}>
                  {values?.field_personalstreet || "-"}
                </div>
              </div>
              <div className={baseStyles.detailItem}>
                <div className={baseStyles.detailLabel}>City</div>
                <div className={baseStyles.detailValue}>
                  {values?.field_personalcity || "-"}
                </div>
              </div>
              <div className={baseStyles.detailItem}>
                <div className={baseStyles.detailLabel}>State</div>
                <div className={baseStyles.detailValue}>
                  {values?.field_personalstate || "-"}
                </div>
              </div>
              <div className={baseStyles.detailItem}>
                <div className={baseStyles.detailLabel}>Zip</div>
                <div className={baseStyles.detailValue}>
                  {values?.field_personalzip || "-"}
                </div>
              </div>
              <div className={baseStyles.detailItem}>
                <div className={baseStyles.detailLabel}>
                  Period of Residence
                </div>
                <div className={baseStyles.detailValue}>
                  {formatPeriod(
                    values?.field_residenceyears,
                    values?.field_residencemonths,
                  ) || "-"}
                </div>
              </div>
            </div>
          </div>

          <div className={baseStyles.section}>
            <SectionHeader
              title="IDENTITY DOCUMENT"
              idvOutcome={getIdvOutcome(idvRows, {
                first_name: values.personal_first_name,
                last_name: values.personal_last_name,
                email: values.personal_email,
              })}
            />
            <div className={baseStyles.detailsGrid}>
              <div className={baseStyles.detailItem}>
                <div className={baseStyles.detailLabel}>ID Type</div>
                <div className={baseStyles.detailValue}>
                  {values?.field_documenttype
                    ? getDocumentType(values?.field_documenttype)
                    : "-"}
                </div>
              </div>
              <div className={baseStyles.detailItem}>
                <div className={baseStyles.detailLabel}>ID Number</div>
                <div className={baseStyles.detailValue}>
                  {values?.field_documentnumber || "-"}
                </div>
              </div>
              <div className={baseStyles.detailItem}>
                <div className={baseStyles.detailLabel}>
                  {values?.field_documenttype === "PASSPORT"
                    ? "Passport Country"
                    : "Document State"}
                </div>
                <div className={baseStyles.detailValue}>
                  {values?.field_documenttype === "PASSPORT"
                    ? getCountryName(values?.document_country)
                    : values?.field_driverstate || "-"}
                </div>
              </div>
              <div className={baseStyles.detailItem}>
                <div className={baseStyles.detailLabel}>
                  Social Security Number
                </div>
                <div className={baseStyles.detailValue}>
                  {values?.field_socialsecurity || "-"}
                </div>
              </div>
              <div className={baseStyles.detailItem}>
                <div className={baseStyles.detailLabel}>Date of Birth</div>
                <div className={baseStyles.detailValue}>
                  {values?.field_birthdate
                    ? dateFormatter(values?.field_birthdate)
                    : "-"}
                </div>
              </div>
            </div>
          </div>

          <div className={baseStyles.section}>
            <SectionHeader title="OWNERSHIP" />
            <div className={baseStyles.detailsGrid}>
              <div className={baseStyles.detailItem}>
                <div className={baseStyles.detailLabel}>
                  Ownership Percentage
                </div>
                <div className={baseStyles.detailValue}>
                  {values.field_ownershippercentage
                    ? `${values.field_ownershippercentage}%`
                    : "-"}
                </div>
              </div>
            </div>
          </div>

          {values.additional_owners &&
            values.additional_owners.length > 0 &&
            values.additional_owners.map((owner, index) => (
              <div key={index} className={baseStyles.section}>
                <SectionHeader
                  title={`ADDITIONAL OWNER #${index + 2}`}
                  idvOutcome={getIdvOutcome(idvRows, {
                    first_name: owner.signer_first_name,
                    last_name: owner.signer_last_name,
                    email: owner.signer_email,
                  })}
                />
                <div className={baseStyles.detailsGrid}>
                  <div className={baseStyles.detailItem}>
                    <div className={baseStyles.detailLabel}>Owner Title</div>
                    <div className={baseStyles.detailValue}>
                      {getOwnerTitle(owner.signer_title)}
                    </div>
                  </div>
                  <div className={baseStyles.detailItem}>
                    <div className={baseStyles.detailLabel}>First Name</div>
                    <div className={baseStyles.detailValue}>
                      {owner.signer_first_name || "-"}
                    </div>
                  </div>
                  <div className={baseStyles.detailItem}>
                    <div className={baseStyles.detailLabel}>Last Name</div>
                    <div className={baseStyles.detailValue}>
                      {owner.signer_last_name || "-"}
                    </div>
                  </div>
                  <div className={baseStyles.detailItem}>
                    <div className={baseStyles.detailLabel}>Personal Phone</div>
                    <div className={baseStyles.detailValue}>
                      {owner.signer_phone || "-"}
                    </div>
                  </div>
                  <div className={baseStyles.detailItem}>
                    <div className={baseStyles.detailLabel}>Personal Email</div>
                    <div className={baseStyles.detailValue}>
                      {owner.signer_email || "-"}
                    </div>
                  </div>
                  <div className={baseStyles.detailItem}>
                    <div className={baseStyles.detailLabel}>City</div>
                    <div className={baseStyles.detailValue}>
                      {owner.signer_city || "-"}
                    </div>
                  </div>
                  <div className={baseStyles.detailItem}>
                    <div className={baseStyles.detailLabel}>State</div>
                    <div className={baseStyles.detailValue}>
                      {owner.signer_state || "-"}
                    </div>
                  </div>
                  <div className={baseStyles.detailItem}>
                    <div className={baseStyles.detailLabel}>Zip</div>
                    <div className={baseStyles.detailValue}>
                      {owner.signer_zip || "-"}
                    </div>
                  </div>
                  <div className={baseStyles.detailItem}>
                    <div className={baseStyles.detailLabel}>
                      Period of Residence
                    </div>
                    <div className={baseStyles.detailValue}>
                      {formatPeriod(
                        owner.signer_residence_years,
                        owner.signer_residence_months,
                      ) || "-"}
                    </div>
                  </div>
                  <div className={baseStyles.detailItem}>
                    <div className={baseStyles.detailLabel}>ID Type</div>
                    <div className={baseStyles.detailValue}>
                      {owner.signer_document_type ? getDocumentType(owner.signer_document_type) : "-"}
                    </div>
                  </div>
                  <div className={baseStyles.detailItem}>
                    <div className={baseStyles.detailLabel}>ID Number</div>
                    <div className={baseStyles.detailValue}>
                      {owner.signer_drivers_license_number || "-"}
                    </div>
                  </div>
                  <div className={baseStyles.detailItem}>
                    <div className={baseStyles.detailLabel}>
                      {owner.signer_document_type === "PASSPORT"
                        ? "Passport Country"
                        : "Document State"}
                    </div>
                    <div className={baseStyles.detailValue}>
                      {owner.signer_document_type === "PASSPORT"
                        ? getCountryName(owner.signer_document_country)
                        : owner.signer_drivers_license_state || "-"}
                    </div>
                  </div>
                  <div className={baseStyles.detailItem}>
                    <div className={baseStyles.detailLabel}>
                      Social Security Number
                    </div>
                    <div className={baseStyles.detailValue}>
                      {owner.signer_social_security || "-"}
                    </div>
                  </div>
                  <div className={baseStyles.detailItem}>
                    <div className={baseStyles.detailLabel}>Date of Birth</div>
                    <div className={baseStyles.detailValue}>
                      {owner.signer_date_of_birth || "-"}
                    </div>
                  </div>
                  <div className={baseStyles.detailItem}>
                    <div className={baseStyles.detailLabel}>
                      Ownership Percentage
                    </div>
                    <div className={baseStyles.detailValue}>
                      {owner.signer_ownership_percentage
                        ? `${owner.signer_ownership_percentage}%`
                        : "-"}
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default PersonalInformation;
